import m from "../../geodata/es2015/bulgariaLow";
window.am4geodata_bulgariaLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/bulgariaLow.js
// module id = null
// module chunks = 